import {
  BellNotification,
  BoxIso,
  CheckCircle,
  EyeClosed,
  EyeSolid,
  OpenSelectHandGesture,
  SendDiagonal,
} from "iconoir-react";
import { IAppViewSection } from "shared/components";

export enum DirectoryKey {
  All = "ALL",
  NotInvited = "NOT_INVITED",
  Invited = "INVITED",
  InvitedAccepted = "INVITED_ACCEPTED",
  NeedsApproval = "NEEDS_APPROVAL",
  Approved = "APPROVED",
  Unpublished = "UNPUBLISHED",
}

// If the count is set to -1, it will show a spinner
export const DirectoryViewSections: IAppViewSection[] = [
  {
    items: [
      {
        Icon: BoxIso,
        key: DirectoryKey.All,
        text: "",
        count: -1,
        isSelected: false,
      },
    ],
  },
  {
    items: [
      {
        Icon: BellNotification,
        key: DirectoryKey.NotInvited,
        text: "",
        count: -1,
        isSelected: false,
      },
      {
        Icon: SendDiagonal,
        key: DirectoryKey.Invited,
        text: "",
        count: -1,
        isSelected: false,
      },
      {
        Icon: OpenSelectHandGesture,
        key: DirectoryKey.InvitedAccepted,
        text: "",
        count: -1,
        isSelected: false,
      },
      {
        Icon: EyeSolid,
        key: DirectoryKey.NeedsApproval,
        text: "",
        count: -1,
        isSelected: false,
      },
      {
        Icon: CheckCircle,
        key: DirectoryKey.Approved,
        text: "",
        count: -1,
        isSelected: false,
      },
    ],
  },
  {
    items: [
      {
        Icon: EyeClosed,
        key: DirectoryKey.Unpublished,
        text: "",
        count: -1,
        isSelected: false,
      },
    ],
  },
];
